import React from "react";
import "./contact-phone.scss";

const ContactPhone = () => (
  <div className="contact-phone">
    <div className="contact-phone__title">Give us a call</div>
    <div className="contact-phone__content">(919) 886-9101</div>
  </div>
);

export default ContactPhone;
